import { colors, Icons, Text } from 'bold-ui'
import { ColorScale, green, orange, red } from 'bold-ui/lib/styles/colors'
import { MChatPerguntaEnum, MChatPerguntaOpcaoEnum, MChatRiscoEnum } from 'graphql/types.generated'

import {
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoViewModel,
} from './consulta-seguimento/model-consultaSeguimento'
import { MChatFieldModel, MChatQueryModel, MChatResultadoModel, MChatViewModel } from './mchat/model-mchat'

export interface MChatRfFieldModel {
  mchat: MChatFieldModel
  consultaSeguimento: ConsultaSeguimentoFieldModel
}

export interface MChatRfViewModel {
  mchat: MChatViewModel | null
  consultaSeguimento: ConsultaSeguimentoViewModel | null
}

export interface UltimosMchatRfQueryModel {
  ultimoMChatR?: MChatQueryModel | null
  ultimoMChatRf?: MChatQueryModel | null
}

export interface MchatRfAplicacaoQueryModel {
  id: ID
  pergunta: MChatPerguntaEnum
  textoPergunta: string
  perguntaOpcao?: MChatPerguntaOpcaoEnum | null
  outros?: string | null
  stPassou?: boolean | null
}

export enum MChatRfAccordionSectionEnum {
  MCHAT = 'MCHAT',
  CONSULTA_SEGUIMENTO = 'CONSULTA_SEGUIMENTO',
}

export type MChatRfResultadoStatus = 'success' | 'warning' | 'danger'

export const MCHAT_RF_ACCORDION_SECTIONS = (
  PILOTO_M_CHAT_RF_ENABLED: boolean
): Record<MChatRfAccordionSectionEnum, { title: string; description: string }> => ({
  MCHAT: {
    title: 'M-CHAT-R™',
    description: 'Aplicação a partir dos 16 meses até 30 meses.',
  },
  CONSULTA_SEGUIMENTO: {
    title: 'Entrevista de seguimento',
    description: `A entrevista de seguimento é recomendada para resultados dentro do Risco Médio no M-CHAT-R.${
      PILOTO_M_CHAT_RF_ENABLED ? '' : ' Acesse o documento original para aplicar a avaliação.'
    }`,
  },
})

export const MCHAT_RF_RESULTADO_BY_STATUS: Record<MChatRfResultadoStatus, { icon: Icons; colorScale: ColorScale }> = {
  success: {
    colorScale: colors.green,
    icon: 'infoCircleOutline',
  },
  warning: {
    colorScale: colors.orange,
    icon: 'exclamationTriangleOutline',
  },
  danger: {
    colorScale: colors.red,
    icon: 'exclamationTriangleOutline',
  },
}

export const MCHAT_RESULTADOS: Record<MChatRiscoEnum, MChatResultadoModel> = {
  BAIXO: {
    status: 'success',
    title: 'Risco baixo',
    shortTitle: 'baixo',
    colorScale: green,
    encaminhamento: (idadeEmMeses: number | undefined) => {
      if (idadeEmMeses && idadeEmMeses < 24) {
        return (
          <Text color='inherit'>
            <strong>Se a criança tem menos de 24 meses, reavaliar após o aniversário de dois anos.</strong> Se houver
            suspeita pela família ou profissional, o M-CHAT-R deverá ser reaplicado, mesmo que o resultado seja de baixo
            risco.
          </Text>
        )
      }
      return (
        <Text color='inherit'>
          Se houver suspeita pela família ou profissional, o M-CHAT-R deverá ser reaplicado, mesmo que o resultado seja
          de baixo risco.
        </Text>
      )
    },
  },
  MEDIO: {
    status: 'warning',
    title: 'Risco médio',
    shortTitle: 'médio',
    colorScale: orange,
    encaminhamento: () => (
      <Text color='inherit'>
        <strong>
          Aplicar M-Chat-R/F&trade; | Entrevista de seguimento para obter informações adicionais sobre as respostas de
          risco, evitando falso positivo.
        </strong>
      </Text>
    ),
  },
  ELEVADO: {
    status: 'danger',
    title: 'Risco elevado',
    shortTitle: 'elevado',
    colorScale: red,
    encaminhamento: () => (
      <Text color='inherit'>
        <strong>
          Não é necessário fazer a Entrevista de seguimento, a criança deve ser encaminhada imediatamente para avaliação
          diagnóstica e intervenção precoce.
        </strong>{' '}
        É necessário acionar as equipes multiprofissionais e/ou atenção especializada.
      </Text>
    ),
  },
  NEGATIVO: {
    status: 'success',
    title: 'Rastreamento negativo',
    shortTitle: 'negativo',
    colorScale: green,
    encaminhamento: () => (
      <Text color='inherit'>
        <strong>Nenhuma outra medida é necessária, a não ser que a vigilância indique risco de TEA.</strong> A criança
        deverá fazer a triagem novamente em futuras consultas de rotina.
      </Text>
    ),
  },
  POSITIVO: {
    status: 'danger',
    title: 'Rastreamento positivo',
    shortTitle: 'positivo',
    colorScale: red,
    encaminhamento: () => (
      <Text color='inherit' fontWeight='bold'>
        É altamente recomendado que a criança seja encaminhada para a intervenção precoce e testagem diagnóstica o mais
        breve possível.
      </Text>
    ),
  },
}
